import React, { Fragment } from "react";
import {
// Table,
  Row,
  Col
} from "reactstrap";
import { getKickCounts } from '../../services'
import kickcounter from "../../../assets/img/healthTools/kickcounter.png";
import HealthcalculatorBtn from "../HealthcalculatorBtn";
import { Accordion, AccordionItem, AccordionItemPanel, AccordionItemHeading, AccordionItemButton } from "react-accessible-accordion";
import BootstrapTable from 'react-bootstrap-table-next';
import { kickColumns } from '../Columns';
import Loader from "../../Loader";


class KickCounter extends React.Component {
  state = {
    collapse: null,
    loading: true,
    documents: []    
  };

  pdfRef = React.createRef();




  toggleCollapse = (id) => {
    if(this.state.collapse === id){
      this.setState({collapse:null})
    }
    else{
      this.setState({collapse: id})
    }
  }



  async componentDidMount() {
    const response = await getKickCounts();
    this.setState(prevState => ({
      documents: response.data.records,
      loading: false
    }))
  }

  generatePdf = () => {

    const { documents } = this.state

    let headers = ["S.No", "Date", "Start time", "End time", "Total kicks"];
    let bodyData = [];
    documents.forEach((document, index) => {
      bodyData.push([index + 1, document._id, document.start, document.end, document.totalKicks]);
    });

    import("../../../utils/downloadPdf")
    .then(({downloadPdfTable}) => {
      downloadPdfTable(headers, bodyData)
    })
    
    
  }

  totalKicks = subdata => {
    return subdata.reduce((totalKicks, kick) => totalKicks + kick.kicks, 0);
  };

  avgKicks = kickcounterData => {
    let totalKicks = kickcounterData.map(data => {
      return this.totalKicks(data.subdata);
    });
    let sum = totalKicks.reduce((sum, i) => sum + i, 0);
    let avg = sum / totalKicks.length;
    return avg;
  };

  render() {
    const { documents  } = this.state;
    if (this.state.loading) {
      return (
        <Loader />
      );
    }

    return (
      <Fragment>
        <Row>
          <Col md={{size : 4}} className="mt-5">
            <div>
              <img src={kickcounter} alt="ovulation" width="100%" />
            </div>
          </Col>
          <Col>
            {documents.length > 0 ?
              <div ref={this.pdfRef}>
                <Accordion className="accordion"
                  allowMultipleExpanded={true}
                  allowZeroExpanded={true}                
                >
                  {documents.map((document, index) => (
                    <AccordionItem className="accordion">
                      <AccordionItemHeading className="accordion__heading">
                        <AccordionItemButton className="accordion__button">
                          <div className="d-flex justify-content-around">
                            <h6>{`Date: ${document._id}`}</h6>
                            <h6>{`Total kicks: ${document.totalKicks}`}</h6>
                          </div>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <BootstrapTable keyField="_id"
                          data={document.records} 
                          columns={kickColumns}
                          headerClasses="tableHeader"
                          bordered={false}
                          striped={true}
                          wrapperClasses="table-responsive" 
                        />
                      </AccordionItemPanel>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
              : <div className="text-center mt-3"><h4>No records found</h4></div>
            }
            <HealthcalculatorBtn generatePdf={this.generatePdf} link="calculator/kick-counter" isPdf={(documents.length > 0)}/>
          </Col>
        </Row>
      </Fragment>
    )

  //   if (successmsg && !errormsg) {
  //     return (
  //       <div>
  //         <div className="row">
  //           <div className="col-md-5">
  //             <p className="text-center"
  //                style={{
  //                  position: "absolute",
  //                  // left: "46.5%",
  //                  fontWeight: 700,
  //                  bottom: "6em",
  //                  color: "white",
  //                  top: "55%",
  //                  left: "46.5%",
  //                  transform: "translate(-50%, -50%)"
  //                }}
  //             >
  //               {Math.round(this.avgKicks(kickcounterData))}
  //             </p>
  //             <img src={kickcounter} width="100%" alt=""/>
  //           </div>

  //           <div className="col-md-7">
  //             <Card>
  //               <CardBody>
  //                 <ListGroup>
  //                   {kickcounterData.map((data, i) => {
  //                     return (
  //                       <CounterCollapse
  //                         data={data}
  //                         key={i}
  //                         totalKicks={this.totalKicks}
  //                         index={i}
  //                         toggle={() => this.toggleCollapse(i)}
  //                         isActive={this.state.collapse === i ? true : false}
  //                       />
  //                     )
  //                   })}
  //                 </ListGroup>
  //               </CardBody>
  //             </Card>
  //           </div>
  //         </div>
  //         <HealthcalculatorBtn />
  //       </div>
  //     );
  //   }

  //   if (!successmsg && errormsg) {
  //     return (
  //       <div className="text-center" style={{ margin: "10em auto" }}>
  //         <p style={{ color: "#535771" }}>
  //           <img src={sad} className="mb-4" alt="" />
  //           {errormsg}
  //         </p>
  //       </div>
  //     );
  //   }
  // }
  }
}

export default KickCounter;



// WEBPACK FOOTER //
// ./src/views/HealthTools/KickCounter/KickCounter.js